// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VarinerTable_wrapper__SPWh7"};